import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  shoplazzaGetListings: data => axios({ baseURL, url: '/api/listings/shoplazza/listings', method: 'post', data }), // 获取listing列表
  shoplazzaSyncListings: data => axios({ baseURL, url: '/api/listings/shoplazza/syncListings', method: 'post', data }), // 手动同步listing
  shoplazzaListingDetail: params => axios({ baseURL, url: '/api/listings/shoplazza/listingDetail', method: 'get', params }), // 根据id获取listing详情   编辑状态
  shoplazzaEdit: data => axios({ baseURL, url: '/api/listings/shoplazza/listing', method: 'put', data }), // 编辑提交
  shoplazzaAdd: data => axios({ baseURL, url: '/api/listings/shoplazza/listing', method: 'post', data }), // 新增提交
  shoplazzaSyncCollections: params => axios({ baseURL, url: '/api/listings/shoplazza/syncCollections', method: 'get', params }), // 同步Collection
  shoplazzaGetCollections: params => axios({ baseURL, url: '/api/listings/shoplazza/collections', method: 'get', params }), // 获取Collection
  shoplazzaListingStatus: data => axios({ baseURL, url: '/api/listings/shoplazza/listingStatus', method: 'put', data }), // 批量上架&上架&批量下架&下架
  shoplazzaListingDelete: data => axios({ baseURL, url: '/api/listings/shoplazza/listings', method: 'delete', data }) // 删除&批量删除Listing
}
